/* eslint-disable react-hooks/exhaustive-deps */
import { DragEvent, useEffect, useRef } from "react"
import { CONTAINER_SIZE, DIALOG_SIZE, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILanding, ILandingSection, LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { ISectionMarkingProps } from "./SectionMarking"

/* Protopia Ecosystem component */
export interface ISectionContainerHandlerProps extends ISectionMarkingProps {
   
}
const SectionContainerHandler = (props: ISectionContainerHandlerProps): JSX.Element => {  
    const settings  = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings ) 
    const ref       = useRef( null )
    const sizes     = useLandingSize()
    const container = props.section.composition?.container || DIALOG_SIZE.NORMAL
    const startDragX= useSyncState<number>( 0 ) 
    const x         = useSyncState<number>( 0 )    

    const getSectionSizes = () : DOMRect => {
        const sectionElement = (ref.current as any)?.closest(".landing-section-container.landing-gap") 
        return sectionElement?.getBoundingClientRect() || {}
    }
    
    const secSizes = getSectionSizes()

    useEffect(() => { 
        const secSizes = getSectionSizes()
        x.set( ( secSizes.width - parseInt( CONTAINER_SIZE[ container ].toString() ) + secSizes.left ) / 2 - 10)
    }, [ sizes, props.section, settings.linesAndHandlers, settings.meatContainerHandler ])

    const onDragStart = (evt: DragEvent) => { 
        evt.dataTransfer.setDragImage(evt.currentTarget, window.outerWidth, window.outerHeight)
        startDragX.set( evt.clientX - x.get() ) 
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach((s: any) => s.style.visibility = "hidden")
        const layoutCell: any = document.querySelector(`.landing-layout-cell-container`)
        if(!!layoutCell) {
            layoutCell.style.visibility = "visible"
        } 
        evt.stopPropagation()
    }
    const onDrag = (evt: DragEvent) => { 
        const x1            = evt.clientX - startDragX.get()
        const landingWidth  = secSizes.width
        const attract = getContainerAttract( x1, landingWidth )
        const xx = getContainerGap(attract,  landingWidth, secSizes )
        if( xx >= 0 ) { 
            x.set( xx )
        }
        evt.stopPropagation()
    }
    const onDragEnd = (evt: DragEvent) => {
        const x1 = evt.clientX - startDragX.get()
        const landingWidth  = secSizes.width
        const attract = getContainerAttract( x1, landingWidth )
        const xx = getContainerGap(attract,  landingWidth, secSizes )
        if( xx  >= 0 ) {
            x.set( xx )
            const currentLanding: ILanding = { ...useLandingStore.getState().currentLanding }
            const newContainer = attract
            const newVal = {
                currentLanding: {
                    ...currentLanding,
                    sections: currentLanding.sections.map((section: ILandingSection, i) => {
                        if(i === props.i) {
                            return {
                                ...section,
                                composition: {
                                    ...section.composition,
                                    container: newContainer
                                }
                            }
                        }
                        return section
                    })
                },
                needUpdate: true
            } 
            useLandingStore.setState(newVal)
        } 
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach((s: any) => s.style.visibility = "visible")
        const layoutCell: any = document.querySelector(`.landing-layout-cell-container`)
        if(!!layoutCell) {
            layoutCell.style.visibility = "hidden"
        }
        evt.stopPropagation()
    }

    return settings.linesAndHandlers && settings.meatContainerHandler && sizes.width > WINDOW_WIDTH.TABLET
        ?
        <div 
            className='landing-section-container-handler pe-surface'
            style={{
                left: x.get() || 0,
            }}
            ref={ ref }
            draggable
            onDragStart={onDragStart}
            onDrag={onDrag}
            onDragEnd={onDragEnd}    
        >
            <div className="landing-section-p">
                { container }
            </div>
        </div>
        :
        <></>
}
export default SectionContainerHandler


export function getContainerAttract(xPos: number, landingWidth: number): DIALOG_SIZE {
    let attract: DIALOG_SIZE = DIALOG_SIZE.NORMAL;
    (Object.keys( CONTAINER_SIZE) as DIALOG_SIZE[] ).forEach((key: DIALOG_SIZE) => {
        const value = key === "full" ? landingWidth : CONTAINER_SIZE[ key ] 
        const w     = landingWidth - xPos * 2
        const ww    = Math.round(w / value) * value
        // console.log( xPos, ww, value )
        if( ww === value) {
            attract = key
        }
    })
    return attract
}
//отступ слева у контейнеров разных типов
export function getContainerGap( size : DIALOG_SIZE, landingWidth: number, sizes: DOMRect): number {
    let xx = CONTAINER_SIZE[ size ]
    xx = typeof xx === "string" ? landingWidth : xx
    return ( landingWidth - xx + sizes.left / 2 ) / 2
}